export function normalizeInternalPath(value) {
  const raw = String(value || "").trim();
  if (!raw) return "/";
  const withLeadingSlash = raw.startsWith("/") ? raw : `/${raw}`;
  const collapsed = withLeadingSlash.replace(/\/{2,}/g, "/");
  return collapsed === "/" ? "/" : collapsed.replace(/\/+$/, "");
}

export function dashboardPath(value) {
  const path = normalizeInternalPath(value);
  if (path === "/") return "/dashbord";
  return normalizeInternalPath(`/dashbord${path}`);
}

export function isInternalOriginUrl(value, origin) {
  try {
    return new URL(value, origin).origin === origin;
  } catch (_) {
    return false;
  }
}
